
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6029',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6029",
  "head-dlb": "static-1.4702",
  "hs-test-utils": "static-1.7645",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11080",
  "I18n": "static-7.1531",
  "jasmine-runner": "static-1.6114",
  "quartz": "static-1.6523",
  "quartz-core": "static-1.5742",
  "react-dlb": "static-1.67",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.685",
  "enviro": "static-4.371",
  "foundations-components": "static-1.7215",
  "history": "static-4.47",
  "hub-http": "static-1.5872",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11388",
  "icons": "static-2.604",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.6801",
  "PortalIdParser": "static-2.334",
  "quartz-config": "static-1.301",
  "quick-fetch": "static-1.3599",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16286",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5050",
  "react-virtualized": "static-2.91",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18093",
  "signup-ui-lego-core": "static-1.20103",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "ui-addon-react-router-dom": "static-1.9202",
  "ui-images": "static-2.1045",
  "UIComponents": "static-3.8027",
  "usage-tracker": "static-1.6998",
  "usage-tracker-core": "static-1.6848",
  "viral-links-lib": "static-1.6675",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven": "static-3.5564",
  "raven-hubspot": "static-1.5871",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9296",
  "bend-plugin-trellis-migration": "static-1.3098",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2800",
  "quartz-webpack": "static-1.2747",
  "HeadJS": "static-2.681",
  "framer-motion": "static-1.62",
  "hs-test-utils-bend-plugin": "static-1.2756",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "foundations-theming": "static-1.4062",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.3994",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.761",
  "hubspotter-http": "static-1.4348",
  "mobile-manifest-mixins": "static-1.454",
  "quartz-auth": "static-1.198",
  "quartz-head": "static-1.188",
  "quartz-i18n": "static-1.198",
  "quartz-test": "static-1.198",
  "ui-fonts": "static-1.342",
  "sassPrefix": "static-1.149",
  "bend-plugin-foundations-components": "static-1.3484",
  "floating-ui": "static-1.49",
  "foundations-assets": "static-1.4490",
  "foundations-theming-specialty": "static-1.1778",
  "hs-story-utils": "static-1.9092",
  "react-aria": "static-1.58",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.909",
  "superstore": "static-1.4430",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4264",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7711",
  "bender-build-tools": "static-1.2770",
  "bend-plugin-foundations-theming": "static-1.2545",
  "foundations-theming-base": "static-1.3047",
  "stylex": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.9127",
  "hubspotter-http-shared-msw-handlers": "static-1.9125",
  "ts-schema": "static-1.3775"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6029",
  "head-dlb": "/head-dlb/static-1.4702",
  "hs-test-utils": "/hs-test-utils/static-1.7645",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11080",
  "I18n": "/I18n/static-7.1531",
  "jasmine-runner": "/jasmine-runner/static-1.6114",
  "quartz": "/quartz/static-1.6523",
  "quartz-core": "/quartz-core/static-1.5742",
  "react-dlb": "/react-dlb/static-1.67",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.685",
  "enviro": "/enviro/static-4.371",
  "foundations-components": "/foundations-components/static-1.7215",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11388",
  "icons": "/icons/static-2.604",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.6801",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "quartz-config": "/quartz-config/static-1.301",
  "quick-fetch": "/quick-fetch/static-1.3599",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16286",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5050",
  "react-virtualized": "/react-virtualized/static-2.91",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18093",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20103",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9202",
  "ui-images": "/ui-images/static-2.1045",
  "UIComponents": "/UIComponents/static-3.8027",
  "usage-tracker": "/usage-tracker/static-1.6998",
  "usage-tracker-core": "/usage-tracker-core/static-1.6848",
  "viral-links-lib": "/viral-links-lib/static-1.6675",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven": "/raven/static-3.5564",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9296",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3098",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2800",
  "quartz-webpack": "/quartz-webpack/static-1.2747",
  "HeadJS": "/HeadJS/static-2.681",
  "framer-motion": "/framer-motion/static-1.62",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2756",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "foundations-theming": "/foundations-theming/static-1.4062",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.3994",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.761",
  "hubspotter-http": "/hubspotter-http/static-1.4348",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.454",
  "quartz-auth": "/quartz-auth/static-1.198",
  "quartz-head": "/quartz-head/static-1.188",
  "quartz-i18n": "/quartz-i18n/static-1.198",
  "quartz-test": "/quartz-test/static-1.198",
  "ui-fonts": "/ui-fonts/static-1.342",
  "sassPrefix": "/sassPrefix/static-1.149",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3484",
  "floating-ui": "/floating-ui/static-1.49",
  "foundations-assets": "/foundations-assets/static-1.4490",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1778",
  "hs-story-utils": "/hs-story-utils/static-1.9092",
  "react-aria": "/react-aria/static-1.58",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.909",
  "superstore": "/superstore/static-1.4430",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4264",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "bender-build-tools": "/bender-build-tools/static-1.2770",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2545",
  "foundations-theming-base": "/foundations-theming-base/static-1.3047",
  "stylex": "/stylex/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9127",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9125",
  "ts-schema": "/ts-schema/static-1.3775"
}
};
